<kendo-dialog title="Add New Student" *ngIf="showDialog" (close)="hideDialog.emit(); resetForm()" maxHeight="85vh"
    #dialog width="80vw" [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
    <kendo-loader type="converging-spinner" size="large" *ngIf="loading" class="loader"></kendo-loader>

    <div *ngIf="form">
        <form class="k-form k-form-md k-ml-2 k-mr-2" [formGroup]="form">
            <div>
                <kendo-grid *ngIf="isShowGrid" #grid class="student-search-grid" [kendoGridBinding]="duplicateGridData"
                    scrollable="none" [pageSize]="10" [pageable]="true" [sortable]="true" [groupable]="false"
                    [resizable]="false" [columnMenu]="{ filter: true, columnChooser: false }" [loading]="loading"
                    [selectable]="false" [sort]="[{ field: 'studentName', dir: 'asc' }]">

                    <kendo-grid-column field="" [sortable]="false" [width]="40" headerClass="action-column"
                        title="Actions">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            <div kendoToolTip
                                [title]="!dataItem.isPreSchool ? 'There are no actions available for this student.' : '' "
                                showOn="hover">
                                <button kendoButton #anchor [svgIcon]="actionIcon"
                                    (click)="openMenu(dataItem, rowIndex)" fillMode="clear" size="none"
                                    [disabled]="!dataItem?.isPreSchool"> </button>
                            </div>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="studentName" title="Student" [width]="250">
                        <ng-template kendoGridCellTemplate let-data>
                            <div class="name-container">
                                <div class="student-name k-text-ellipsis">{{ data.studentName | titlecase }}</div>
                            </div>
                            <div class="student-id">{{ data.nycId }}</div>
                            <!-- TODO: The size of the kendo chips need to be changed to small, already confirmed this with Michelle -->
                            <div class="name-container"> <kendo-chip
                                    *ngIf="data.atsStatus === 'D' || data.atsStatus === 'DISCHARGED'" rounded="full"
                                    size="large" fillMode="solid" themeColor="warning" class="status-chip closed-chip"
                                    [selected]="true" label="ATS: Discharged">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.atsStatus === 'ACTIVE' || data.atsStatus === 'A'" rounded="full"
                                    size="large" fillMode="solid" themeColor="success" class="status-chip"
                                    [selected]="true" label="ATS: Active">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.refStatus > 0 && data.refStatus !== 7" rounded="full"
                                    size="large" fillMode="solid" themeColor="success" class="status-chip active-chip"
                                    [selected]="true" label="Special Education Status: Active">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.refStatus === 7" rounded="full" size="large" fillMode="solid"
                                    themeColor="warning" class="status-chip closed-chip" [selected]="true"
                                    label="Special Education Status: Inactive">
                                </kendo-chip>
                                <kendo-chip *ngIf="data.ineligibleSE" rounded="full" size="large" fillMode="solid"
                                    themeColor="warning" class="status-chip active-chip" [selected]="true"
                                    label="Special Education Status: Ineligible">
                                </kendo-chip>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="dateOfBirthUnixTimestamp" title="DOB" [width]="100" [resizable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            {{dataItem.dateOfBirth | formatDate}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="gender" title="Gender" [width]="100" [resizable]="false">
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            {{dataItem.gender | titlecase}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="grade" title="Grade" [width]="90" [resizable]="false"></kendo-grid-column>
                    <kendo-grid-column field="school" title="School" [width]="200"></kendo-grid-column>

                    <ng-template kendoGridNoRecordsTemplate>
                        <p *ngIf="!loading">No Student records available</p>
                    </ng-template>

                    <ng-template kendoGridLoadingTemplate>
                        <div class="loading-container">
                            <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
                        </div>
                    </ng-template>
                </kendo-grid>

                <kendo-contextmenu #gridmenu [items]="duplicateStudent?.actions" (select)="onSelect($event)"
                    showOn="click"></kendo-contextmenu>

            </div>

            <div>
                <div class="k-mt-6 k-d-flex">
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="First Name *">
                            <kendo-textbox formControlName="firstName"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('firstName')?.errors?.validateName?.message }}</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Middle Name">
                            <kendo-textbox formControlName="middleName" [maxlength]="15"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Middle Name must be between 1 and 15 characters. Hyphens and spaces are
                            allowed.</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Last Name *">
                            <kendo-textbox formControlName="lastName"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('lastName')?.errors?.validateName?.message }}</kendo-formerror>
                    </kendo-formfield>
                </div>
                <div class="k-mt-6 k-d-flex">
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Gender *">
                            <kendo-dropdownlist [data]="referenceData.sex" [textField]="'description'"
                                [valueField]="'value'" formControlName="gender" [rounded]="'large'" [size]="'medium'">
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Student Date of Birth *">
                            <kendo-datepicker calendarType="classic" rounded="large" formControlName="dob"
                                [max]="threeYearsAgo" placeholder="MM/DD/YYYY" format="MM/dd/yyyy"
                                [min]="minPreschoolDob"></kendo-datepicker>
                        </kendo-floatinglabel>
                        <kendo-formerror *ngIf="form.get('dob').hasError('required')">Error: Selection is
                            mandatory</kendo-formerror>
                        <kendo-formerror *ngIf="form.get('dob').hasError('minError')">Error: Does not meet age
                            requirement for initial referral</kendo-formerror>
                        <kendo-formerror *ngIf="form.get('dob').hasError('maxError')">Error: Does not meet age
                            requirement for initial referral</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Home Borough *">
                            <kendo-dropdownlist [data]="referenceData.borough" [textField]="'description'"
                                [valueField]="'id'" formControlName="homeBorough" [rounded]="'large'" [size]="'medium'">
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                    </kendo-formfield>

                </div>
                <div class="k-mt-6 k-d-flex">
                    <!-- <kendo-formfield class="k-ml-2 k-w-1/3">
                    <kendo-floatinglabel text="House Number *">
                        <kendo-textbox formControlName="houseNumber"></kendo-textbox>
                    </kendo-floatinglabel>
                    <kendo-formerror>Error: Enter a valid House Number</kendo-formerror>
                </kendo-formfield> -->
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Street Address 1 *">
                            <kendo-textbox formControlName="streetName"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('streetName')?.errors?.validateAddress?.message
                            }}</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Street Address 2">
                            <kendo-textbox formControlName="apartmentNumber"></kendo-textbox>
                        </kendo-floatinglabel>
                        <!--<kendo-formerror>Error: Enter a valid Street Address 2</kendo-formerror>-->
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="City *">
                            <kendo-textbox formControlName="city"
                                (keypress)="allowCityCharacters($event)"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('city')?.errors?.validateCity?.message }}</kendo-formerror>
                    </kendo-formfield>

                </div>
                <div class="k-mt-6 k-d-flex">


                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="State *">
                            <kendo-dropdownlist [data]="referenceData.state" [textField]="'description'"
                                [valueField]="'id'" formControlName="state" [rounded]="'large'" [size]="'medium'">
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Zip *">
                            <kendo-textbox formControlName="zip" appMinLength="5"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('zip')?.errors?.validateZipCode?.message }}</kendo-formerror>
                        <kendo-formhint>Formats: 12345, 12345-6789, 12345 6789, or 123456789</kendo-formhint>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="School District *">
                            <kendo-dropdownlist [data]="referenceData.district" [textField]="'description'"
                                [valueField]="'id'" formControlName="schoolDistrict" [rounded]="'large'"
                                [size]="'medium'">
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                    </kendo-formfield>
                </div>
                <div class="k-mt-6 k-d-flex">

                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Parent/Guardian Relationship *">
                            <kendo-dropdownlist [data]="referenceData.relationship" [textField]="'description'"
                                [valueField]="'id'" formControlName="guardianRelationship" [rounded]="'large'"
                                [size]="'medium'">
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                    </kendo-formfield>
                </div>


                <div class="k-mt-6 k-d-flex">
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Parent/Guardian First Name *">
                            <kendo-textbox formControlName="guardianFirstName"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('guardianFirstName')?.errors?.validateName?.message
                            }}</kendo-formerror>
                    </kendo-formfield>
                    <kendo-formfield class="k-ml-2 k-w-1/3">
                        <kendo-floatinglabel text="Parent/Guardian Last Name *">
                            <kendo-textbox formControlName="guardianLastName"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ form.get('guardianLastName')?.errors?.validateName?.message
                            }}</kendo-formerror>
                    </kendo-formfield>
                </div>
            </div>

            <div class="k-mt-2 k-justify-content-end k-d-flex">
                <div>
                    <button type="button" kendoButton themeColor="error" size="large" rounded="large" fillMode="outline"
                        [disabled]="canSubmit" (click)="hideDialog.emit(); resetForm()">
                        Cancel
                    </button>
                </div>
                <div class="k-ml-2">
                    <button type="button" kendoButton themeColor="primary" size="large" rounded="large" fillMode="solid"
                        [disabled]="form.invalid || loading" (click)="submit(false)">
                        {{isShowGrid? 'Create Duplicate' : 'Submit'}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</kendo-dialog>